












import { defineComponent, Ref } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import MypageSwitchToPaidPlanPane from '@/components/MypageSwitchToPaidPlanPage/MypageSwitchToPaidPlanPane.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * お得なお知らせ: ログイン後に表示するトライアル広告ページ
 */
export default defineComponent({
  name: 'SpecialOfferTrialAdsPage',
  components: {
    SubHeaderSection,
    MypageSwitchToPaidPlanPane,
  },
  setup() {
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')
    const { isPurchasingInAppPurchase } = mypagePageStore

    return {
      isPurchasingInAppPurchase: isPurchasingInAppPurchase as Ref<boolean>,
    }
  },
})
